import packageJson from '../../package.json';

export const environment = {
    production: false,
    name: 'Aktion Lichtblicke e.V.',
    version: packageJson.version,
    apiEndpoint: 'https://lichtblicke-dev.hosting.it-objects.de/api',
    apiBasePath: '',
};
